import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  Input,
  ViewChild
} from '@angular/core';

import { FormButtonComponent } from '../button/form-button';

import { OptionComponentAbstract } from './option-component.abstract';

@Component({
  selector: 'shrd-uic-flyout-option',
  templateUrl: './flyout-option.component.html',
  styleUrls: ['./flyout-option.component.scss'],
  providers: [
    {
      provide: OptionComponentAbstract,
      useExisting: FlyoutOptionComponent
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FlyoutOptionComponent extends OptionComponentAbstract {
  @Input() className = 'my-0';
  @Input() highlightedContent: string;
  @Input() enableFormButton = false;

  @HostBinding('class.shrd-uic-flyout-option') baseClass = true;
  @ViewChild('formButton') formButton: FormButtonComponent;
  @ViewChild('button') button: ElementRef;
  constructor(elRef: ElementRef, cdr: ChangeDetectorRef) {
    super(elRef, cdr);
  }

  focus(): void {
    this.getButton().focus();
  }

  blur(): void {
    this.getButton().blur();
  }

  getButton(): HTMLElement {
    return (this.enableFormButton ? this.formButton.button : this.button).nativeElement;
  }
}
